import { TAnswer } from 'shared/types/faq';
import { Row } from '../Row';

interface IBlockProps {
  content: TAnswer[];
}

export const Block: React.FC<IBlockProps> = ({ content }) => {
  return (
    <p>
      {content.map((row, index) => (
        <Row key={index} content={row} />
      ))}
    </p>
  );
};
